module.exports = __webpack_public_path__ + "static/img/pic_verification.ebd00b52.png";